(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('desktop-jewelry-menu')) {
  customElements.define('desktop-jewelry-menu', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const region = this.closest('.header__primary-nav-item');
      const button = this.querySelector('button');

      const setOpen = (open) => {
        this.toggleAttribute('data-open', open);
        button.setAttribute('aria-expanded', String(open));
      };

      region.addEventListener('mouseenter', () => {
        this.removeAttribute('data-dismissed');
        setOpen(true);
      }, options);

      region.addEventListener('mouseleave', () => {
        this.removeAttribute('data-dismissed');
        setOpen(region.contains(document.activeElement));
      }, options);

      button.addEventListener('click', () => {
        this.removeAttribute('data-dismissed');
        setOpen(true);
      }, options);

      this.addEventListener('focusin', () => setOpen(true), options);

      this.addEventListener('focusout', (event) => {
        if (!region.contains(event.relatedTarget)) setOpen(false);
      }, options);

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        button.focus();
        setOpen(false);
        this.setAttribute('data-dismissed', '');
      }, options);

      document.addEventListener('pointerdown', (event) => {
        if (!region.contains(event.target)) setOpen(false);
      }, options);
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
